import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import AuthFormShell from '../../components/AuthFormShell.jsx'
import Logo from '../../components/Logo.jsx'
import { useAuth } from '../../context/AuthContext.jsx'
import './authTitam.css'

export default function ForgotPassword() {
  const navigate = useNavigate()
  const { resetPassword } = useAuth()
  const [email, setEmail] = useState('')
  const [error, setError] = useState('')
  const [success, setSuccess] = useState('')
  const [loading, setLoading] = useState(false)

  async function handleSubmit(event) {
    event.preventDefault()
    setError('')
    setSuccess('')
    setLoading(true)

    const { error: resetError } = await resetPassword(email)

    if (resetError) {
      setError(resetError.message || 'Nao foi possivel enviar o link agora.')
      setLoading(false)
      return
    }

    setLoading(false)
    setSuccess('Se esse e-mail existir, enviamos um link para redefinir sua senha.')
  }

  return (
    <AuthFormShell
      showcaseVariant="titam"
      showcaseTitle="Recupere o acesso à sua conta."
      showcaseDescription="Informe seu e-mail e enviaremos um link seguro para você redefinir a senha e voltar ao painel."
    >
      <form className="auth-form-wrap auth-titam-form" onSubmit={handleSubmit}>
        <span className="auth-form-logo">
          <Logo height={14} />
        </span>
        <h1 className="auth-title">Recuperar senha</h1>
        <p className="auth-desc">
          Informe seu e-mail e enviamos um link para redefinir o acesso.
        </p>

        {error ? <div className="auth-error">{error}</div> : null}
        {success ? <div className="auth-success">{success}</div> : null}

        <div className="field">
          <label className="field-label" htmlFor="forgot-email">
            E-mail
          </label>
          <input
            id="forgot-email"
            className="input"
            type="email"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
            autoComplete="email"
            required
          />
        </div>

        <button className="btn btn-full auth-titam-submit" type="submit" disabled={loading}>
          {loading ? 'Enviando...' : 'Enviar link de recuperacao'}
        </button>

        <div className="auth-switch">
          Lembrou a senha?{' '}
          <button type="button" onClick={() => navigate('/login')}>
            Voltar para login
          </button>
        </div>
      </form>
    </AuthFormShell>
  )
}
